<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Shuttles</ion-title>
        <!-- @if (!vb.disabled) {
  <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
} -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        <!-- {{shuttles.length}} shuttles defined. Click + to add a shuttle or tap to edit a shuttle -->
        {{shuttlesDefinedStr}}
    </ion-list-header>

    <ion-list class="ion-padding" data-test="shuttles">
        @for (shuttle of shuttles; track $index) {
        <ion-item-sliding>
            <ion-item detail="true" data-test="shuttle" href="javascript:;" (click)="onShuttleClick(shuttle.uid)">
                <ion-label>
                    <span class="line1">{{shuttle.shuttleName}}</span><br />
                    @if (shuttle.description) {
                    <div>
                        <span class="line2">{{shuttle.description}}</span><br />
                    </div>
                    }
                    <span class="line2">Passenger Capacity: {{shuttle.passengerCapacity}}</span><br />
                    <span class="line2">Status: {{shuttle.status}}</span><br />
                    <span class="line2">Color: {{shuttle.color}}</span>
                </ion-label>
            </ion-item>
            <ion-item-options>
                <ion-button id="deleteShuttle" color="danger" (click)="confirmDeleteShuttle(shuttle)">
                    <ion-icon name="trash"></ion-icon>
                    Delete
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Add" data-test="addShuttleBtn" href="javascript:;"
            (click)="onAddShuttle()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>